import { Component, HostBinding, HostListener, Input } from "@angular/core";
import "./vertical-collapsable-divider.component.scss";

@Component({
    selector: "vertical-collapsable-divider",
    template: require("./vertical-collapsable-divider.component.html")
})
export class VerticalCollapsableDivider {
    @Input() @HostBinding("class.collapsed") collapsed: boolean;

    @HostListener('click') myClick() {
        this.collapsed = !this.collapsed;
    }
}
